import CheckmarkIcon from '~/components/Icons/svgs/CheckmarkIcon'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'

export function SuccessMessage({ text }: { text: string }): React.ReactElement {
  return (
    <div>
      <div className="flex justify-center text-md font-medium">
        <SVGIcon icon={CheckmarkIcon} pathClassName="text-green" size={20} />
      </div>
      <div className="flex justify-center text-green text-md font-medium">{text}</div>
    </div>
  )
}
